(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var header = document.getElementById('st-header');
  var burger = document.getElementById('st-burger');
  var menu   = document.getElementById('st-mobile-menu');
  if (!header) return;

  // Burger toggle
  if (burger && menu) {
    burger.addEventListener('click', function() {
      var isOpen = header.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', String(isOpen));
      menu.setAttribute('aria-hidden', String(!isOpen));
    });
    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        header.classList.remove('menu-open');
        burger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // Shrink header on scroll
  window.addEventListener('scroll', function() {
    header.classList.toggle('st-header--scrolled', window.scrollY > 20);
  }, { passive: true });

  // ── Smooth scroll with cubic easing (Framer-style) ───────────────────────
  function easeInOutCubic(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2, 3)/2; }

  function smoothScrollTo(targetY, duration) {
    var startY = window.pageYOffset;
    var distance = targetY - startY;
    if (Math.abs(distance) < 2) return;
    var startTime = performance.now();
    function step(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function getHeaderOffset() {
    return (header.offsetHeight || 0) + 16;
  }

  function handleAnchorClick(e) {
    var link = e.currentTarget;
    var href = link.getAttribute('href') || '';
    var hashIdx = href.indexOf('#');
    if (hashIdx === -1) return;
    var hash = href.slice(hashIdx);
    if (hash.length < 2) return;
    var target;
    try { target = document.querySelector(hash); } catch (_) { return; }
    if (!target) return;
    var pathPart = href.slice(0, hashIdx);
    var samePath = pathPart === '' || pathPart === '/' || pathPart === window.location.pathname || pathPart === window.location.origin + window.location.pathname;
    if (!samePath) return;
    e.preventDefault();
    var rect = target.getBoundingClientRect();
    var targetY = rect.top + window.pageYOffset - getHeaderOffset();
    smoothScrollTo(targetY, 850);
    if (history.pushState) history.pushState(null, '', hash);
  }

  document.querySelectorAll('.st-header__link, .st-mobile-menu__link').forEach(function(a) {
    a.addEventListener('click', handleAnchorClick);
  });

  // Smooth-scroll on initial page load if URL has a hash
  if (window.location.hash && window.location.hash.length > 1) {
    setTimeout(function() {
      var t;
      try { t = document.querySelector(window.location.hash); } catch (_) { return; }
      if (!t) return;
      var rect = t.getBoundingClientRect();
      var targetY = rect.top + window.pageYOffset - getHeaderOffset();
      window.scrollTo(0, 0);
      requestAnimationFrame(function(){ smoothScrollTo(targetY, 1100); });
    }, 80);
  }

  // ── Section reveal-on-scroll (Framer-style) ──────────────────────────────
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.st-hero, .st-section, .st-cta');
    revealEls.forEach(function(el) { el.classList.add('st-reveal'); });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el) { io.observe(el); });

    // Hero is already in view at load — reveal immediately
    var hero = document.querySelector('.st-hero');
    if (hero) {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { hero.classList.add('is-visible'); });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('st-announcement-bar');
  if (!bar) return;
  var isAr = bar.dataset.locale === 'ar';

  fetch('/apps/slime-time/settings', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(data) {
      var s = (data && data.settings) || {};
      var text = isAr ? (s.announcement_text_ar || '') : (s.announcement_text_en || '');
      if (!text) return;
      var key = 'st-ann-' + btoa(text).slice(0, 12);
      if (sessionStorage.getItem(key)) return;

      var link = s.announcement_link || '';
      if (link) {
        var a = document.getElementById('st-announcement-link');
        a.href = link;
        a.querySelector('#st-announcement-text').textContent = text;
        a.style.display = '';
      } else {
        var span = document.getElementById('st-announcement-span');
        span.querySelector('span').textContent = text;
        span.style.display = '';
      }
      bar.style.display = '';

      document.getElementById('st-announcement-dismiss').addEventListener('click', function() {
        bar.style.display = 'none';
        sessionStorage.setItem(key, '1');
      });
    })
    .catch(function(){});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-booking-form"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (typeof window.slimeBooking === 'undefined') return;
  var B = window.slimeBooking;
  var isAr = B.isAr;
  var QAR  = B.qar;

  var SLOTS = [
    '10:00 AM – 12:00 PM',
    '01:00 PM – 03:00 PM',
    '04:00 PM – 06:00 PM',
    '07:00 PM – 09:00 PM'
  ];

  var STEP_NAMES = isAr
    ? ['التاريخ والوقت','تفاصيل الحفلة','الإضافات','بياناتك','المراجعة']
    : ['Date & Time','Party Details','Add-Ons','Your Info','Review'];

  var state = {
    step: 0, date: null, timeSlot: '',
    kids: '', kidsVariantId: 0, kidsPrice: 0,
    occasion: '', tables: 0, chairs: 0, notes: '',
    name: '', phone: '', email: '', submitting: false
  };

  // Booking always starts at step 0 (Date & Time) — package is selected on step 1 by the customer.
  // Old URLs with ?package= still work but no longer pre-select / skip ahead.

  var content     = document.getElementById('st-step-content');
  var stepLabel   = document.getElementById('st-step-label');
  var stepName    = document.getElementById('st-step-name');
  var progressBar = document.getElementById('st-progress-bar');
  var totalBar    = document.getElementById('st-total-bar');
  var totalAmt    = document.getElementById('st-total-display');
  var stepNav     = document.getElementById('st-step-nav');
  var btnBack     = document.getElementById('st-btn-back');
  var btnNext     = document.getElementById('st-btn-next');

  function calcTotal() {
    return state.kidsPrice + (state.tables * B.tablePrice) + (state.chairs * B.chairPrice);
  }

  function canNext() {
    switch (state.step) {
      case 0: return !!state.date && !!state.timeSlot;
      case 1: return !!state.kids;
      case 2: return true;
      case 3: return !!state.name && isValidPhone(state.phone);
      default: return true;
    }
  }

  // Convert Arabic-Indic (٠-٩) and Persian/Urdu (۰-۹) numerals to ASCII digits
  function arabicToWestern(s) {
    return String(s || '')
      .replace(/[٠-٩]/g, function(d){ return String.fromCharCode(d.charCodeAt(0) - 0x0660 + 0x30); })
      .replace(/[۰-۹]/g, function(d){ return String.fromCharCode(d.charCodeAt(0) - 0x06F0 + 0x30); });
  }

  function isValidPhone(p) {
    var western = arabicToWestern(p).replace(/[\s\-]/g,'');
    return /^(\+?974)?[0-9]{8}$/.test(western);
  }

  function renderStep() {
    var n = state.step + 1;
    stepLabel.textContent = (isAr ? 'الخطوة ' : 'Step ') + n + (isAr ? ' من ' : ' of ') + STEP_NAMES.length;
    stepName.textContent  = STEP_NAMES[state.step] || '';
    progressBar.style.width = (n / STEP_NAMES.length * 100) + '%';
    stepNav.style.display = '';
    btnBack.style.display = state.step > 0 ? '' : 'none';
    btnNext.style.display = state.step === 4 ? 'none' : '';
    btnNext.disabled = !canNext();
    var total = calcTotal();
    if (state.step >= 1 && state.step < 4 && total > 0) {
      totalAmt.textContent = total + ' ' + QAR;
      totalBar.style.display = '';
    } else {
      totalBar.style.display = 'none';
    }
    switch (state.step) {
      case 0: renderStep0(); break;
      case 1: renderStep1(); break;
      case 2: renderStep2(); break;
      case 3: renderStep3(); break;
      case 4: renderStep4(); break;
    }
  }

  function renderStep0() {
    content.innerHTML =
      '<h2>' + (isAr ? 'اختر التاريخ والوقت' : 'Pick a Date & Time') + '</h2>' +
      '<div id="st-cal-wrap" class="st-calendar-wrap" style="margin-bottom:.75rem;"></div>' +
      '<div id="st-viewers" class="st-viewers" style="display:none;"><span class="st-viewers__dot"></span><span id="st-viewers-count"></span></div>' +
      '<p style="font-size:.875rem;color:var(--st-muted-text);margin:.75rem 0 .4rem;">' + (isAr ? 'اختر فترة ساعتين' : 'Select a 2-hour slot') + '</p>' +
      '<div class="st-slots" id="st-slots-list"></div>';
    buildCalendar('st-cal-wrap');
    renderSlots();
  }

  var viewerTimer = null;
  function startViewers(dt) {
    clearInterval(viewerTimer);
    var el = document.getElementById('st-viewers');
    var cel = document.getElementById('st-viewers-count');
    if (!el || !cel) return;
    var day = dt.getDay();
    var min = (day===5||day===6)?15:(day===4?6:2);
    var max = (day===5||day===6)?32:(day===4?14:8);
    function rnd(a,b){return Math.floor(Math.random()*(b-a+1))+a;}
    var n = rnd(min,max);
    var label = isAr
      ? ' شخصاً يشاهدون هذا التاريخ الآن'
      : ' people are looking at this date now';
    cel.textContent = n + label;
    el.style.display = '';
    viewerTimer = setInterval(function(){
      n = Math.max(min,Math.min(max,n+rnd(-2,2)));
      cel.textContent = n + label;
    }, rnd(3000,6000));
  }

  function buildCalendar(id) {
    var wrap = document.getElementById(id);
    if (!wrap) return;
    var today = new Date(); today.setHours(0,0,0,0);
    var viewing = state.date
      ? new Date(state.date.getFullYear(), state.date.getMonth(), 1)
      : new Date(today.getFullYear(), today.getMonth(), 1);
    var months = isAr
      ? ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر']
      : ['January','February','March','April','May','June','July','August','September','October','November','December'];
    // Sun → Sat (index = Date.getDay())
    var dayLabels = isAr
      ? ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت']
      : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var dayLabelsShort = isAr
      ? ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت']
      : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

    var iconPrev = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    var iconNext = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    function draw() {
      var y=viewing.getFullYear(), m=viewing.getMonth();
      var fd=new Date(y,m,1).getDay(), dim=new Date(y,m+1,0).getDate();
      var monthFirst = new Date(y,m,1); monthFirst.setHours(0,0,0,0);
      var prevDisabled = monthFirst <= new Date(today.getFullYear(), today.getMonth(), 1);

      var h='<div class="st-cal">';
      h+='<div class="st-cal__head">';
      h+='<button type="button" class="st-cal__nav" id="cp" aria-label="'+(isAr?'الشهر السابق':'Previous month')+'"'+(prevDisabled?' disabled':'')+'>'+(isAr?iconNext:iconPrev)+'</button>';
      h+='<div class="st-cal__title">'+months[m]+' '+y+'</div>';
      h+='<button type="button" class="st-cal__nav" id="cn" aria-label="'+(isAr?'الشهر التالي':'Next month')+'">'+(isAr?iconPrev:iconNext)+'</button>';
      h+='</div>';

      h+='<div class="st-cal__grid st-cal__grid--head">';
      for (var di=0; di<7; di++) {
        h+='<div class="st-cal__dow" title="'+dayLabels[di]+'">'+dayLabelsShort[di]+'</div>';
      }
      h+='</div>';

      h+='<div class="st-cal__grid st-cal__grid--body">';
      for(var e=0;e<fd;e++) h+='<div class="st-cal__cell st-cal__cell--blank"></div>';
      for(var dd=1;dd<=dim;dd++){
        var dt=new Date(y,m,dd); dt.setHours(0,0,0,0);
        var past = dt < today;
        var sel = state.date && dt.getTime() === state.date.getTime();
        var isToday = dt.getTime() === today.getTime();
        var cls = 'st-cal__cell';
        if (past) cls += ' st-cal__cell--past';
        if (sel) cls += ' st-cal__cell--selected';
        if (isToday && !sel) cls += ' st-cal__cell--today';
        var attrs = past ? ' aria-disabled="true" tabindex="-1"' : ' tabindex="0"';
        h+='<button type="button" class="'+cls+'" data-ts="'+dt.getTime()+'"'+attrs+'>'+dd+'</button>';
      }
      h+='</div></div>';
      wrap.innerHTML=h;

      wrap.querySelectorAll('.st-cal__cell').forEach(function(el){
        if (el.classList.contains('st-cal__cell--past') || el.classList.contains('st-cal__cell--blank')) return;
        el.addEventListener('click', function(){
          var dt=new Date(parseInt(el.dataset.ts));
          state.date = dt; state.timeSlot = '';
          draw(); renderSlots();
          startViewers(dt);
          btnNext.disabled = !canNext();
        });
      });
      var cp = document.getElementById('cp');
      var cn = document.getElementById('cn');
      cp.addEventListener('click', function(){ if (cp.disabled) return; viewing.setMonth(viewing.getMonth()-1); draw(); });
      cn.addEventListener('click', function(){ viewing.setMonth(viewing.getMonth()+1); draw(); });
    }
    draw();
  }

  function renderSlots() {
    var list = document.getElementById('st-slots-list');
    if (!list) return;
    list.innerHTML = '';
    SLOTS.forEach(function(slot) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'st-slot' + (state.timeSlot===slot ? ' active' : '');
      btn.textContent = slot;
      btn.addEventListener('click', function(){ state.timeSlot=slot; renderSlots(); btnNext.disabled=!canNext(); });
      list.appendChild(btn);
    });
  }

  function renderStep1() {
    var h = '<h2>' + (isAr?'تفاصيل الحفلة':'Party Details') + '</h2>';
    h += '<p style="font-size:.875rem;color:var(--st-muted-text);margin-bottom:.5rem;">' + (isAr?'عدد الأطفال *':'Number of Kids *') + '</p>';
    h += '<div class="st-pills" id="kids-pills">';
    B.packages.forEach(function(pkg) {
      h += '<button type="button" class="st-pill' + (state.kids===pkg.kidsLabel?' active':'') + '" data-kids="'+pkg.kidsLabel+'" data-variant="'+pkg.variantId+'" data-price="'+pkg.price+'">' + pkg.kidsLabel + '</button>';
    });
    h += '</div>';
    h += '<p style="font-size:.875rem;color:var(--st-muted-text);margin:.75rem 0 .5rem;">' + (isAr?'المناسبة':'Occasion') + '</p>';
    var occs = isAr
      ? ['عيد ميلاد','فعالية مدرسية','أخرى']
      : ['Birthday','School Event','Other'];
    h += '<div class="st-pills" id="occ-pills">';
    occs.forEach(function(occ, i) {
      var isOther = i === 2;
      var isActive = isOther ? state.occasion==='__other__' : state.occasion===occ;
      h += '<button type="button" class="st-pill'+(isActive?' active':'') + '" data-occ="'+(isOther?'__other__':occ)+'">'+occ+'</button>';
    });
    h += '</div>';
    h += '<input type="text" id="occ-custom" class="st-input" placeholder="'+(isAr?'اكتب المناسبة (اختياري)':'Type occasion (optional)')+'" value="'+(state.occasion!=='__other__'&&occs.indexOf(state.occasion)===-1?state.occasion:'')+'" style="margin-top:.5rem;display:'+(state.occasion==='__other__'||(state.occasion&&occs.indexOf(state.occasion)===-1)?'':'none')+';">';
    content.innerHTML = h;

    content.querySelectorAll('[data-kids]').forEach(function(btn){
      btn.addEventListener('click', function(){
        state.kids=btn.dataset.kids;
        state.kidsVariantId=parseInt(btn.dataset.variant);
        state.kidsPrice=parseFloat(btn.dataset.price);
        content.querySelectorAll('[data-kids]').forEach(function(b){b.classList.toggle('active',b===btn);});
        btnNext.disabled=!canNext();
        var total=calcTotal();
        if(total>0){totalAmt.textContent=total+' '+QAR;totalBar.style.display='';}
      });
    });
    content.querySelectorAll('[data-occ]').forEach(function(btn){
      btn.addEventListener('click', function(){
        state.occasion=btn.dataset.occ;
        content.querySelectorAll('[data-occ]').forEach(function(b){b.classList.toggle('active',b===btn);});
        document.getElementById('occ-custom').style.display=state.occasion==='__other__'?'':'none';
      });
    });
    document.getElementById('occ-custom').addEventListener('input',function(e){state.occasion=e.target.value;});
  }

  function renderStep2() {
    var each = isAr ? 'للقطعة' : 'each';
    content.innerHTML =
      '<h2>' + (isAr?'الإضافات':'Add-Ons') + '</h2>' +
      mkCounter('tables', isAr?'طاولات':'Tables', isAr?'تتسع لـ ٤':'fits 4', B.tablePrice, state.tables, each) +
      mkCounter('chairs', isAr?'كراسي':'Chairs', '', B.chairPrice, state.chairs, each) +
      '<textarea id="notes-in" class="st-input" rows="3" placeholder="'+(isAr?'طلبات خاصة أو أي شيء نحتاج معرفته…':'Special requests or anything we should know…')+'" style="resize:none;margin-top:.75rem;">'+(state.notes||'')+'</textarea>';

    function wire(id, key) {
      document.getElementById(id+'-dec').onclick=function(){state[key]=Math.max(0,state[key]-1);document.getElementById(id+'-val').textContent=state[key];totalAmt.textContent=calcTotal()+' '+QAR;};
      document.getElementById(id+'-inc').onclick=function(){state[key]++;document.getElementById(id+'-val').textContent=state[key];totalAmt.textContent=calcTotal()+' '+QAR;};
    }
    wire('tables','tables'); wire('chairs','chairs');
    document.getElementById('notes-in').oninput=function(e){state.notes=e.target.value;};
  }

  function mkCounter(id, label, hint, price, val, each) {
    return '<div class="st-addon-row" style="margin-bottom:.5rem;">' +
      '<div><span style="font-weight:600;">'+label+'</span>' +
      (hint?'<span style="font-size:.8rem;color:var(--st-muted-text);margin-inline-start:.4rem;">'+hint+'</span>':'')+
      '<span style="font-size:.8rem;color:var(--st-muted-text);margin-inline-start:.4rem;">'+price+' '+QAR+' '+each+'</span></div>' +
      '<div class="st-counter">'+
        '<button type="button" class="st-counter-btn" id="'+id+'-dec">−</button>'+
        '<span class="st-counter-val" id="'+id+'-val">'+val+'</span>'+
        '<button type="button" class="st-counter-btn" id="'+id+'-inc">+</button>'+
      '</div></div>';
  }

  function renderStep3() {
    content.innerHTML =
      '<h2>'+(isAr?'بياناتك':'Your Details')+'</h2>' +
      '<div style="display:flex;flex-direction:column;gap:1rem;">' +
        '<input type="text" id="name-in" class="st-input" placeholder="'+(isAr?'الاسم *':'Your Name *')+'" value="'+state.name+'">' +
        '<div>' +
          '<input type="tel" id="phone-in" class="st-input" placeholder="'+(isAr?'رقم الهاتف * (مثال: 55001234)':'Phone Number * (e.g. 55001234)')+'" value="'+state.phone+'" maxlength="15" dir="ltr">' +
          '<p id="phone-err" style="font-size:.8rem;color:#ef4444;margin-top:4px;display:none;">'+(isAr?'يرجى إدخال رقم هاتف قطري صحيح (٨ أرقام)':'Please enter a valid Qatari phone number (8 digits)')+'</p>' +
        '</div>' +
        '<input type="email" id="email-in" class="st-input" placeholder="'+(isAr?'البريد الإلكتروني (اختياري)':'Email (optional)')+'" value="'+state.email+'" dir="ltr">' +
      '</div>';
    document.getElementById('name-in').oninput=function(e){state.name=e.target.value;btnNext.disabled=!canNext();};
    document.getElementById('phone-in').oninput=function(e){
      // Normalize Arabic-Indic numerals to ASCII before storing
      var raw = e.target.value;
      state.phone = arabicToWestern(raw);
      document.getElementById('phone-err').style.display=state.phone&&!isValidPhone(state.phone)?'':'none';
      btnNext.disabled=!canNext();
    };
    document.getElementById('email-in').oninput=function(e){state.email=e.target.value;};
  }

  function renderStep4() {
    var total = calcTotal();
    var dateStr = state.date ? state.date.toLocaleDateString(isAr?'ar-EG':'en-GB') : '';
    var occ = state.occasion==='__other__' ? '' : state.occasion;

    var h = '<h2>'+(isAr?'المراجعة والتأكيد':'Review & Confirm')+'</h2>';
    h += '<p style="font-size:.8rem;color:var(--st-muted-text);margin-bottom:1rem;">'+(isAr?'راجع تفاصيلك قبل تأكيد الحجز':'Check your details before confirming the booking')+'</p>';
    h += '<div class="st-summary">';
    h += sRow(isAr?'الاسم':'Name', state.name);
    h += sRow(isAr?'الهاتف':'Phone', state.phone);
    h += sRow(isAr?'التاريخ':'Date', dateStr);
    h += sRow(isAr?'الوقت':'Time', state.timeSlot);
    h += sRow(isAr?'عدد الأطفال':'Kids', state.kids);
    if (occ) h += sRow(isAr?'المناسبة':'Occasion', occ);
    h += sRow(isAr?'الطاولات':'Tables', String(state.tables));
    h += sRow(isAr?'الكراسي':'Chairs', String(state.chairs));
    if (state.notes) h += sRow(isAr?'ملاحظات':'Notes', state.notes);
    h += '</div>';
    h += '<div class="st-summary" style="margin-top:.75rem;">';
    h += sRow(isAr?'الباقة':'Package', state.kidsPrice + ' ' + QAR);
    if (state.tables>0) h += sRow((isAr?'طاولات':'Tables')+' ×'+state.tables, (state.tables*B.tablePrice)+' '+QAR);
    if (state.chairs>0) h += sRow((isAr?'كراسي':'Chairs')+' ×'+state.chairs, (state.chairs*B.chairPrice)+' '+QAR);
    h += '<div class="st-summary-row" style="font-weight:700;font-size:1rem;padding-top:.5rem;"><span>'+(isAr?'المجموع':'Total')+'</span><span>'+total+' '+QAR+'</span></div>';
    h += '</div>';
    h += '<p style="font-size:.8rem;color:var(--st-muted-text);margin-top:.75rem;text-align:center;">'+(isAr?'سيتم تحويلك إلى صفحة دفع آمنة لإتمام الحجز. أو اختر واتساب للدفع لاحقاً.':'You\'ll be redirected to a secure checkout to complete your booking. Or choose WhatsApp to pay later.')+'</p>';
    h += '<div style="display:flex;flex-direction:column;gap:.75rem;margin-top:1.25rem;">';
    h += '<button type="button" id="st-confirm-btn" class="st-btn st-btn--primary" style="width:100%;justify-content:center;font-size:1.05rem;">';
    h += '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" style="flex-shrink:0"><path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5z" stroke="currentColor" stroke-width="2"/><path d="M3 9h18M7 15h2m4 0h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg> ';
    h += (isAr?'تأكيد الحجز والدفع':'Confirm & Pay') + '</button>';
    h += '<button type="button" id="st-wa-btn" class="st-btn st-btn--whatsapp" style="width:100%;justify-content:center;">';
    h += '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style="flex-shrink:0"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> ';
    h += (isAr?'متابعة عبر واتساب':'Continue via WhatsApp') + '</button>';
    h += '</div>';
    content.innerHTML = h;
    btnNext.style.display = 'none';

    document.getElementById('st-confirm-btn').addEventListener('click', submitBookingAndPay);
    document.getElementById('st-wa-btn').addEventListener('click', submitBookingViaWhatsApp);
  }

  function sRow(label, val) {
    return '<div class="st-summary-row"><span style="color:var(--st-muted-text);">'+label+'</span><span style="font-weight:500;">'+val+'</span></div>';
  }

  // ── Build booking payload (shared by both flows) ─────────────────────────
  function buildBookingData() {
    var occ = state.occasion==='__other__'?'':state.occasion;
    var dateStr = state.date.getFullYear()+'-'+String(state.date.getMonth()+1).padStart(2,'0')+'-'+String(state.date.getDate()).padStart(2,'0');
    return { occ: occ, dateStr: dateStr };
  }

  function buildWhatsAppMessage() {
    var total = calcTotal();
    var occ = state.occasion==='__other__'?'':state.occasion;
    var dateStr = state.date ? state.date.toLocaleDateString('en-GB') : '';
    return '🎉 *Slime Time Booking*\n' +
      '👤 ' + state.name + '\n📞 ' + state.phone +
      '\n📅 ' + dateStr + '\n⏰ ' + state.timeSlot +
      '\n👧 ' + state.kids + '\n🎂 ' + (occ||'—') +
      '\n🪑 Tables: ' + state.tables + '\n💺 Chairs: ' + state.chairs +
      '\n💰 Total: ' + total + ' ' + QAR +
      '\n📝 ' + (state.notes||'None');
  }

  // ── Flow 1: Confirm & Pay → Shopify cart → native checkout (SkipCash) ────
  // The booking metadata is attached as line item properties + cart attributes
  // (which appear as note_attributes on the resulting Shopify Order). The
  // app's orders/paid webhook reads them back to create the Booking row.
  function submitBookingAndPay() {
    if (state.submitting || !state.kidsVariantId) return;
    state.submitting = true;
    var btn = document.getElementById('st-confirm-btn');
    if (btn) { btn.disabled=true; btn.textContent=isAr?'جاري التحويل للدفع…':'Redirecting to payment…'; }

    var d = buildBookingData();

    // Line item property names ARE shown to the customer on the checkout
    // order summary, so they need to be localised. We also stash an English
    // copy under a hidden ("_") prefix so the orders/paid webhook can read
    // them back regardless of the locale the booking was placed in.
    var packageProps = {};
    if (isAr) {
      packageProps['التاريخ']    = d.dateStr;
      packageProps['الوقت']      = state.timeSlot;
      packageProps['عدد الأطفال'] = state.kids;
      packageProps['المناسبة']   = d.occ || '—';
      packageProps['ملاحظات']    = state.notes || '—';
    } else {
      packageProps['Date']     = d.dateStr;
      packageProps['Time']     = state.timeSlot;
      packageProps['Kids']     = state.kids;
      packageProps['Occasion'] = d.occ || '—';
      packageProps['Notes']    = state.notes || '—';
    }
    // Hidden machine-readable copy (any property whose name starts with "_"
    // is hidden from the storefront). The webhook reads these.
    packageProps['_meta_date']     = d.dateStr;
    packageProps['_meta_time']     = state.timeSlot;
    packageProps['_meta_kids']     = state.kids;
    packageProps['_meta_occasion'] = d.occ || '';
    packageProps['_meta_notes']    = state.notes || '';

    var items = [{ id: state.kidsVariantId, quantity: 1, properties: packageProps }];
    if (state.tables > 0 && B.tableVariantId) items.push({ id: B.tableVariantId, quantity: state.tables });
    if (state.chairs > 0 && B.chairVariantId) items.push({ id: B.chairVariantId, quantity: state.chairs });

    // Cart-level attributes — these become note_attributes on the order. They
    // are NOT shown to the customer at checkout, only to the merchant in the
    // admin order page, so they stay in English for consistency.
    var attrs = {
      'Source': 'web',
      'Event Date': d.dateStr,
      'Time Slot': state.timeSlot,
      'Kids': state.kids,
      'Occasion': d.occ || '—',
      'Notes': state.notes || '—',
      'Customer Name (form)': state.name || '',
      'Customer Phone (form)': state.phone || '',
      'Locale': B.locale,
    };

    function jsonPost(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        if (!r.ok) return r.text().then(function(t){ throw new Error('cart ' + r.status + ': ' + t.slice(0, 200)); });
        return r.json();
      });
    }

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(){ return jsonPost('/cart/update.js', { attributes: attrs }); })
      .then(function(){ return jsonPost('/cart/add.js', { items: items }); })
      .then(function(){
        // Pre-fill the checkout. Digital products skip shipping, so we send
        // both shipping AND billing keys (Shopify uses whichever is relevant).
        // Country=QA + City=Doha pre-select the country/city dropdowns so the
        // customer just confirms and pays.
        var qs = [];
        if (state.email) qs.push('checkout[email]=' + encodeURIComponent(state.email));
        var first = '', last = '';
        if (state.name) {
          var parts = state.name.trim().split(/\s+/);
          first = parts[0] || state.name;
          last  = parts.slice(1).join(' ') || first;
        }
        ['shipping_address', 'billing_address'].forEach(function(key){
          if (first) qs.push('checkout[' + key + '][first_name]=' + encodeURIComponent(first));
          if (last)  qs.push('checkout[' + key + '][last_name]='  + encodeURIComponent(last));
          if (state.phone) qs.push('checkout[' + key + '][phone]=' + encodeURIComponent(state.phone));
          qs.push('checkout[' + key + '][country]=Qatar');
          qs.push('checkout[' + key + '][city]=Doha');
        });
        window.location.href = '/checkout' + (qs.length ? '?' + qs.join('&') : '');
      })
      .catch(function(err){
        state.submitting = false;
        if (btn) { btn.disabled=false; btn.textContent=isAr?'تأكيد الحجز والدفع':'Confirm & Pay'; }
        alert(isAr?'حدث خطأ في تحضير سلة الدفع. حاول عبر واتساب من فضلك.':'Could not prepare checkout. Please try WhatsApp instead.');
        console.error('Cart prep error:', err);
      });
  }

  // ── Flow 2: WhatsApp → Order via App Proxy (no payment) → Countdown ─────
  function submitBookingViaWhatsApp() {
    if (state.submitting || !state.kidsVariantId) return;
    state.submitting = true;
    var btn = document.getElementById('st-wa-btn');
    if (btn) { btn.disabled=true; btn.textContent=isAr?'جاري إنشاء الحجز…':'Creating booking…'; }

    var d = buildBookingData();
    var waMsg = buildWhatsAppMessage();
    var waUrl = 'https://wa.me/' + B.waNumber + '?text=' + encodeURIComponent(waMsg);

    var payload = {
      customer_name: state.name,
      phone: state.phone,
      email: state.email || '',
      event_date: d.dateStr,
      time_slot: state.timeSlot,
      kids_label: state.kids,
      occasion: d.occ,
      tables_count: state.tables,
      chairs_count: state.chairs,
      notes: state.notes,
      package_variant_id: state.kidsVariantId,
      table_variant_id: B.tableVariantId,
      chair_variant_id: B.chairVariantId,
      source: 'whatsapp'
    };

    fetch(B.bookingEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function(r){
        var ct = r.headers.get('content-type') || '';
        if (!ct.includes('application/json')) throw new Error('Backend unavailable');
        return r.json().then(function(d){ return { ok: r.ok, data: d }; });
      })
      .then(function(res){
        if (res.ok && res.data.ok) {
          showWhatsAppCountdown(waUrl, res.data.order_name || ('#'+res.data.order_number));
        } else {
          throw new Error((res.data && res.data.error) || 'Order failed');
        }
      })
      .catch(function(err){
        // Fallback: open WhatsApp anyway, show informational countdown without order number
        console.warn('App proxy unavailable, fallback to direct WhatsApp:', err.message);
        showWhatsAppCountdown(waUrl, null);
      });
  }

  // ── Countdown screen with SVG progress ring ──────────────────────────────
  function showWhatsAppCountdown(waUrl, orderName) {
    btnBack.style.display = 'none';
    btnNext.style.display = 'none';
    totalBar.style.display = 'none';

    var seconds = 5;
    var orderLine = orderName
      ? '<p style="color:var(--st-muted-text);font-size:.95rem;margin:0 0 .25rem;">'+(isAr?'رقم الطلب':'Order')+' <strong style="color:var(--st-text);">'+orderName+'</strong></p>'
      : '';

    content.innerHTML =
      '<div style="text-align:center;padding:1.5rem 1rem;">' +
        '<div style="font-size:3rem;margin-bottom:.5rem;">✅</div>' +
        '<h2 style="color:var(--st-primary);margin:0 0 .5rem;">'+(isAr?'تم استلام حجزك!':'Booking Received!')+'</h2>' +
        orderLine +
        '<p style="color:var(--st-muted-text);font-size:.95rem;margin:.25rem 0 1.5rem;">'+(isAr?'سيتم تحويلك إلى واتساب لتأكيد الحجز وترتيب الدفع':'Redirecting to WhatsApp to confirm and arrange payment')+'</p>' +

        '<div class="st-countdown" aria-hidden="true">' +
          '<svg class="st-countdown__ring" viewBox="0 0 100 100" width="120" height="120">' +
            '<circle cx="50" cy="50" r="45" class="st-countdown__bg"/>' +
            '<circle cx="50" cy="50" r="45" class="st-countdown__progress"/>' +
          '</svg>' +
          '<div class="st-countdown__num" id="st-countdown-num">' + seconds + '</div>' +
        '</div>' +

        '<p style="color:var(--st-muted-text);font-size:.85rem;margin:1.25rem 0 1rem;">'+(isAr?'سيتم التحويل إلى واتساب خلال':'Redirecting in')+' <span id="st-cd-text">'+seconds+'</span> '+(isAr?'ثوان…':'seconds…')+'</p>' +

        '<div style="display:flex;flex-direction:column;gap:.5rem;max-width:300px;margin:0 auto;">' +
          '<button type="button" id="st-go-now" class="st-btn st-btn--whatsapp" style="width:100%;justify-content:center;">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> ' +
            (isAr?'الانتقال الآن':'Open WhatsApp Now') +
          '</button>' +
          '<button type="button" id="st-cancel-cd" style="background:none;border:none;color:var(--st-muted-text);font-size:.85rem;cursor:pointer;padding:.5rem;text-decoration:underline;">'+(isAr?'إلغاء':'Cancel')+'</button>' +
        '</div>' +
      '</div>';

    var num = document.getElementById('st-countdown-num');
    var cdText = document.getElementById('st-cd-text');
    var goNow = document.getElementById('st-go-now');
    var cancel = document.getElementById('st-cancel-cd');

    var cancelled = false;
    var timer = setInterval(function() {
      if (cancelled) { clearInterval(timer); return; }
      seconds -= 1;
      if (num) num.textContent = seconds;
      if (cdText) cdText.textContent = seconds;
      if (seconds <= 0) {
        clearInterval(timer);
        if (!cancelled) window.location.href = waUrl;
      }
    }, 1000);

    goNow.addEventListener('click', function() {
      cancelled = true;
      clearInterval(timer);
      window.location.href = waUrl;
    });
    cancel.addEventListener('click', function() {
      cancelled = true;
      clearInterval(timer);
      var ring = document.querySelector('.st-countdown__progress');
      if (ring) ring.style.animationPlayState = 'paused';
      content.innerHTML =
        '<div style="text-align:center;padding:2rem;">' +
          '<p style="color:var(--st-muted-text);">'+(isAr?'تم الإلغاء. حجزك محفوظ في الطلبات.':'Cancelled. Your booking is saved in orders.')+'</p>' +
        '</div>';
    });
  }

  btnNext.addEventListener('click',function(){if(!canNext())return;state.step=Math.min(4,state.step+1);renderStep();});
  btnBack.addEventListener('click',function(){state.step=Math.max(0,state.step-1);renderStep();});

  renderStep();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.st-faq-q').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.closest('.st-faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.st-faq-item').forEach(function(i) {
      i.classList.remove('open');
      var b = i.querySelector('.st-faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('gallery');
  var grid = document.getElementById('st-gallery-grid');
  if (!section || !grid) return;
  var emptyMsg = section.dataset.emptyMsg || '';
  var isRtl = section.dataset.rtl === '1';

  var lightbox = document.getElementById('st-lightbox');
  var lbImg = lightbox.querySelector('[data-lb-img]');
  var lbCounter = lightbox.querySelector('[data-lb-counter]');
  var lbClose = lightbox.querySelector('[data-lb-close]');
  var lbPrev = lightbox.querySelector('[data-lb-prev]');
  var lbNext = lightbox.querySelector('[data-lb-next]');

  var images = [];
  var currentIndex = 0;
  var touchStartX = 0;
  var touchStartY = 0;

  function openLightbox(index) {
    currentIndex = index;
    showImage();
    lightbox.hidden = false;
    requestAnimationFrame(function(){
      lightbox.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('st-no-scroll');
    document.addEventListener('keydown', onKey);
  }
  function closeLightbox() {
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('st-no-scroll');
    document.removeEventListener('keydown', onKey);
    setTimeout(function(){ lightbox.hidden = true; }, 200);
  }
  function showImage() {
    var img = images[currentIndex];
    if (!img) return;
    lbImg.src = img.imageUrl;
    lbImg.alt = img.altText || 'Slime Time';
    lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
    lbImg.style.animation = 'none';
    void lbImg.offsetWidth;
    lbImg.style.animation = '';
  }
  function navigate(delta) {
    if (!images.length) return;
    currentIndex = (currentIndex + delta + images.length) % images.length;
    showImage();
  }
  function onKey(e) {
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') navigate(isRtl ? 1 : -1);
    else if (e.key === 'ArrowRight') navigate(isRtl ? -1 : 1);
  }

  lbClose.addEventListener('click', closeLightbox);
  lbPrev.addEventListener('click', function(){ navigate(isRtl ? 1 : -1); });
  lbNext.addEventListener('click', function(){ navigate(isRtl ? -1 : 1); });
  lightbox.addEventListener('click', function(e){
    if (e.target === lightbox) closeLightbox();
  });

  lightbox.addEventListener('touchstart', function(e){
    if (!e.touches || !e.touches[0]) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  lightbox.addEventListener('touchend', function(e){
    if (!e.changedTouches || !e.changedTouches[0]) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      navigate(dx < 0 ? (isRtl ? -1 : 1) : (isRtl ? 1 : -1));
    }
  }, { passive: true });

  fetch('/apps/slime-time/gallery', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(data) {
      images = (data && data.images) || [];
      if (!images.length) {
        grid.innerHTML = '<p class="st-subtitle st-text-center" style="grid-column:1/-1;color:var(--st-muted-text);padding:2rem;">' + emptyMsg + '</p>';
        return;
      }
      grid.innerHTML = '';
      images.forEach(function(img, idx) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'st-gallery-item';
        item.setAttribute('aria-label', img.altText || 'Open image');
        var altSafe = String(img.altText || 'Slime Time').replace(/"/g, '&quot;');
        item.innerHTML = '<img src="' + img.imageUrl + '" alt="' + altSafe + '" loading="lazy">';
        item.addEventListener('click', function(){ openLightbox(idx); });
        grid.appendChild(item);
      });
    })
    .catch(function() {
      grid.innerHTML = '<p class="st-subtitle st-text-center" style="grid-column:1/-1;color:#ef4444;">Could not load gallery.</p>';
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-payment-bridge"] && !Shopify.designMode) return;
  try {
    
(function() {
  // SkipCash redirects here after a payment attempt. Three contexts:
  //   1. Inside an iframe (modal flow)  → postMessage to window.parent
  //   2. Inside a popup window           → postMessage to window.opener, close
  //   3. Top-level navigation            → fall back to /pages/thank-you
  // The booking form ALSO polls our backend, so even if postMessage drops
  // the redirect will still happen via the polling path.

  var params = new URLSearchParams(window.location.search);
  var bookingId = params.get('booking') || params.get('id') || '';
  var status    = params.get('status') || params.get('result') || 'success';
  var paymentId = params.get('paymentId') || params.get('payment_id') || '';

  var payload = {
    type: 'st-skipcash-result',
    bookingId: bookingId,
    paymentId: paymentId,
    status: status,
  };

  var target = null;
  try {
    if (window.parent && window.parent !== window) target = window.parent;
    else if (window.opener && !window.opener.closed) target = window.opener;
  } catch (e) { target = null; }

  if (target) {
    try { target.postMessage(payload, '*'); } catch (e) {}
    setTimeout(function(){ try { window.close(); } catch (e) {} }, 250);
  } else {
    var qs = bookingId ? '?booking=' + encodeURIComponent(bookingId) : '';
    window.location.replace('/pages/thank-you' + qs);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('#reviews');
  var grid = document.getElementById('st-reviews-grid');
  if (!section || !grid) return;
  var isAr = section.dataset.locale === 'ar';
  var emptyMsg = section.dataset.emptyMsg || '';

  fetch('/apps/slime-time/reviews', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(data) {
      var reviews = (data && data.reviews) || [];
      if (reviews.length === 0) {
        grid.innerHTML = '<p class="st-subtitle st-text-center" style="grid-column:1/-1;">'+emptyMsg+'</p>';
        return;
      }
      grid.innerHTML = '';
      reviews.forEach(function(r) {
        var stars = '★'.repeat(Math.min(r.rating || 5, 5));
        var text = (isAr && r.reviewAr) ? r.reviewAr : (r.reviewEn || '');
        var name = (isAr && r.customerNameAr) ? r.customerNameAr : (r.customerName || '');
        var initial = (name || 'A').trim().slice(0, 1).toUpperCase();
        var avatar = r.imageUrl
          ? '<img src="' + r.imageUrl + '" alt="' + escapeAttr(name) + '" class="st-review__avatar" loading="lazy">'
          : '<div class="st-review__avatar-placeholder">' + initial + '</div>';
        var card = document.createElement('div');
        card.className = 'st-review';
        if (isAr) card.setAttribute('dir', 'rtl');
        card.innerHTML =
          '<div class="st-review__header">' + avatar +
          '<div><div class="st-review__name">' + escapeHtml(name) + '</div>' +
          '<div class="st-review__stars">' + stars + '</div></div></div>' +
          '<p class="st-review__text">' + escapeHtml(text) + '</p>';
        grid.appendChild(card);
      });
    })
    .catch(function() {
      grid.innerHTML = '<p class="st-subtitle st-text-center" style="grid-column:1/-1;color:#ef4444;">Could not load reviews.</p>';
    });

  function escapeHtml(s) {
    var d = document.createElement('div'); d.textContent = String(s || ''); return d.innerHTML;
  }
  function escapeAttr(s) { return String(s || '').replace(/"/g, '&quot;'); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slime-thank-you"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Get booking ID from URL
  var params = new URLSearchParams(window.location.search);
  var bookingId = params.get('booking') || params.get('id');

  if (bookingId) {
    fetch('/apps/slime-time/booking-detail?id=' + encodeURIComponent(bookingId), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var b = data && data.booking;
        if (!b) return;
        var section = document.getElementById('thank-you');
        var isAr = section && section.dataset.locale === 'ar';
        var box = document.getElementById('st-booking-summary');
        var content = document.getElementById('st-summary-content');
        if (!box || !content) return;

        var labels = isAr ? {
          order: 'رقم الطلب', date: 'التاريخ', time: 'الوقت', kids: 'عدد الأطفال',
          customer: 'الاسم', phone: 'الهاتف', total: 'المجموع'
        } : {
          order: 'Order', date: 'Date', time: 'Time', kids: 'Kids',
          customer: 'Name', phone: 'Phone', total: 'Total'
        };
        var qar = isAr ? 'ر.ق' : 'QAR';
        var rows = '';
        function row(l, v) { return '<div class="st-summary-row"><span style="color:var(--st-muted-text);">' + l + '</span><span style="font-weight:500;">' + v + '</span></div>'; }
        if (b.shopifyOrderNumber) rows += row(labels.order, '#' + b.shopifyOrderNumber);
        rows += row(labels.date, b.eventDate);
        rows += row(labels.time, b.timeSlot);
        rows += row(labels.kids, b.kidsLabel);
        rows += row(labels.customer, b.customerName);
        rows += row(labels.phone, b.phone);
        if (b.totalPrice > 0) rows += row(labels.total, b.totalPrice + ' ' + qar);
        content.innerHTML = rows;
        box.style.display = '';
      })
      .catch(function(){});
  }
})();

  } catch(e) { console.error(e); }
})();
})();
